/// <reference path="./TBox/Section.ts" />
namespace HA.Core.HTML {
    import Section = HA.Core.HTML.TBox.Section;

    export class TextBox extends Box {

        /**
         * @return {Tag}
         * @param data
         */
        protected createByType(data: Map<any, any>) {
            switch (data.get("t")) {
                case "s":
                    return new Section({d: data.get("d")});
                case "t1":
                    const tag = new Div(data.get("d"));
                    tag.addClass("t1");
                    return tag;
                case "img":
                    return new Img(data.get("d"));
                default :
                    return null;
            }
        }

        protected createSelf() {
            super.createSelf();
            this.addClass("tbox");
            const c = new CFlexContainer();
            const me = this;
            let tdata = this.get("tdata");
            if (!tdata) {
                tdata = this.getData();
                tdata.forEach((item: any) => {
                    c.appendChild(new TextField(item));
                });
            } else {
                tdata.forEach((item: any) => {
                    c.appendChild(me.createByType(toMap(item)));
                });
            }

            this.appendChild(c);
        }
    }
}
